import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { ROOT_URL } from '../../../config/global.js';
import '../../../../styles/scss/style.css';

//Components
import TextHeadingOne from '../../atoms/TextHeadingTwo';
import TextParagraph from '../../atoms/TextParagraph';
import FormButton from '../../atoms/FormButton';
import LabeledTextfield from '../../molecules/LabeledTextfield';
import LabeledTextarea from '../../molecules/LabeledTextarea';
import Modal from '../../organisms/Modal';
import LabeledSelect from '../../molecules/LabeledSelect';
import { strings } from './FormCreateBotContent';

//Returning the component
class FormCreateBot extends Component {
	constructor(props) {
		super(props);

		this.state = {
			bots: this.props.userBots,
			modalClass: this.props.modalClass,
			updateState: this.props.updateState,
			selectedValue: 'en',
			selectedBotId: '',
			botName: '' // Saves the value of the input field
		}

		this.createBot = this.createBot.bind(this);
		this.updateBot = this.updateBot.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleSelectchange = this.handleSelectchange.bind(this);
		this.confirmChange = this.confirmChange.bind(this);
	}
	componentWillReceiveProps(nextProps) {
		// Helps to open and close the pop up
		this.setState({
			bots: nextProps.userBots,
			modalClass: nextProps.modalClass,
			updateState: nextProps.updateState,
			selectedBotId: nextProps.selectedBot.selectedBot ? nextProps.selectedBot.selectedBot._id : '',
			botName: nextProps.selectedBot.selectedBot ? nextProps.selectedBot.selectedBot.name : '',
		});

		if (nextProps.selectedBot.selectedBot) {
			if (nextProps.selectedBot.selectedBot.language) {
				this.setState({ selectedValue: nextProps.selectedBot.selectedBot ? nextProps.selectedBot.selectedBot.language : '' });
			}
		}
	}
	createBot(e) {
		e.preventDefault();
		// Adding loading state to store
		this.props.loading(true);

		// Hide the modal
		this.setState({ modalClass: '', updateState: '' });

		const createBotRequest = axios({
			method: 'post',
			url: `${ROOT_URL}/api/bots`,
			data: {
				name: this.state.botName, //Bot name
				language: this.state.selectedValue
			}
		});

		// Updates the store with the new login status
		createBotRequest.then((botReqAnswer) => {
			let currentBots = this.props.currentBots;
			currentBots.push(botReqAnswer.data);
			// Fetching the status from the server again, updating the store.
			this.props.fetchBots();
			this.props.loading(false);

		}).catch((error) => {
			this.setState({ error: error.response });
		});
	}
	updateBot(e) {
		e.preventDefault();
		// Adding loading state to store
		this.props.loading(true);

		// Hide the modal
		this.setState({ modalClass: '', updateState: '' });

		const createBotRequest = axios({
			method: 'put',
			url: `${ROOT_URL}/api/bots/${this.state.selectedBotId}`,
			data: {
				name: this.state.botName //Bot name
			}
		});

		// Updates the store with the new login status
		createBotRequest.then((botReqAnswer) => {
			let currentBots = this.props.currentBots;
			currentBots.push(botReqAnswer.data);
			// Fetching the status from the server again, updating the store.
			this.props.fetchBots();
			this.props.loading(false);

		}).catch((error) => {
			this.setState({ error: error.response });
		});
	}
	handleSelectchange(e) {
		this.setState({ selectedValue: e.target.value });
	}
	confirmChange(e) {
		// Trigger onBlur, updates the state on auto-fill events
		this.handleChange(e);
	}
	handleChange({ target }) {
		this.setState({
			[target.name]: target.value
		});
	}
	render() {
		return (
			<Modal modalClass={this.state.modalClass}>
				<form className={`form ${this.props.formWrapperClassType}`}>
					<TextHeadingOne text={this.state.updateState ? strings.headingUpdate : strings.heading} />
					<TextParagraph text={strings.paragraph} />

					{/* Botname */}
					<LabeledTextfield
						formGroupClassType={this.props.formGroupClassType}
						labelFor="Botname"
						labelText={strings.botInput.text}
						labelId="botName"
						textfieldClassType={this.props.textfieldClassType}
						textfieldId="botName"
						textfieldPlaceholder={strings.botInput.placeholder}
						textfieldName="botName"
						value={this.state.botName}
						onChange={this.handleChange}
						onBlur={this.confirmChange}
						textfieldForm={this.props.textFieldForm}
						errorMessageClassType={this.props.errorMessageClassType}
						errorMessageText={strings.botInput.errorMessageText}
					/>

					<LabeledSelect
						formGroupClassType=""
						labelFor="language"
						labelText="Language"
						labelId="language"
						selectedValue={this.state.selectedValue}
						selectOnChange={this.handleSelectchange}
						selectData={strings.languagesSelect}
						selectClassType={this.state.updateState ? 'btn--disabled' : ''}
						selectId="Language"
						selectName="Language"
						selectChildren="Language"
						selectRequired="required"
						errorMessageClassType="Value"
						errorMessageText="error"
					/>

					{/* Description */}
					<LabeledTextarea
						formGroupClassType={this.props.formGroupClassType}
						labelFor="description"
						labelText={strings.descriptionTextArea.text}
						labelId="description"
						textareaClassType={this.props.textareaClassType}
						textareaId="description"
						textareaPlaceholder={strings.descriptionTextArea.placeholder}
						textareaName="description"
						textareaForm={this.props.textareaForm}
						textareaOnChange={this.handleChange}
						errorMessageClassType={this.props.errorMessageClassType}
						errorMessageText={strings.descriptionTextArea.errorMessageText}
					/>

					<FormButton text={this.state.updateState ? strings.button.textUpdate : strings.button.text} classType="btn--fullWidth" onClick={this.state.updateState ? (e) =>this.updateBot(e) : (e) => this.createBot(e)} />
				</form>
			</Modal>
		)
	}
}

FormCreateBot.propTypes = {
	formGroupClassType: PropTypes.string,
	textareaClassType: PropTypes.string,
	textFieldForm: PropTypes.string,
	textFieldOnChange: PropTypes.string,
	errorMessageClassType: PropTypes.string,
}


export default FormCreateBot;


// WEBPACK FOOTER //
// ./src/redux/components/organisms/FormCreateBot/FormCreateBot.jsx